import React from 'react';
import { useSelector } from 'react-redux';
import { ORGANIZATION_TYPE } from '../../config/constants';

function Footer() {
  const today = new Date();
  const { org } = useSelector(({ auth }) => auth);

  if (org.type === ORGANIZATION_TYPE.WHITE_LABELED) {
    return (
      <footer
        className="main-footer"
        style={{
          textAlign: 'center',
          borderTop: '1px solid rgba(0,0,0,0.05)',
          margin: '3em 0 1em 0',
          padding: '20px',
          color: '#444',
          fontSize: '12px',
        }}
      >
        Powered by {org?.name}. &copy; {today.getFullYear()} {org?.name}, All Rights Reserved.
      </footer>
    );
  }

  return (
    <footer
      className="main-footer"
      style={{
        textAlign: 'center',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        margin: '3em 0 1em 0',
        padding: '20px',
        color: '#444',
        fontSize: '12px',
      }}
    >
      Powered by SellerGeni. &copy; {today.getFullYear()} SellerGeni (P) Ltd, All Rights Reserved.
    </footer>
  );
}

export default Footer;
